import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import Moment from 'moment';

const DataTable = ({ isLoading, tableColumn, dataSource, totalRecord, dataFilter, onChangePage, deleteRecord }) => {
    const statusOptionList = [
        { value: 1, label: 'Pending' },
        { value: 2, label: 'Placed' },
        { value: 3, label: 'Accept' },
        { value: 4, label: 'Processing' },
        { value: 5, label: 'Out for delivery' },
        { value: 6, label: 'Delivered' },
        { value: 7, label: 'Canceled' },
        { value: 8, label: 'Rejected' },
        { value: 9, label: 'Returned' },
    ];

    const paymentStatusOptionList = [
        { value: 1, label: 'Unpaid' },
        { value: 2, label: 'Paid' },
        { value: 3, label: 'Failed' },
        { value: 4, label: 'Waiting For Approval' },
    ];

    return (
        <TableWrapServerSide tableColumnList={tableColumn} totalDataCount={totalRecord} initialPage={dataFilter?.page} onChangePage={onChangePage} per_page={dataFilter?.limit}>
            {dataSource && dataSource.length > 0 ? (
                dataSource.map((data) => (
                    <tr className="db-table-body-tr" key={data._id}>
                        <td className="db-table-body-td">{data.order_serial_no}</td>
                        <td className="db-table-body-td">{Moment(data?.order_datetime).format('Y-M-D hh:mm:ss')}</td>
                        <td className="db-table-body-td">
                            {data.order_items && data.order_items.length > 0 ? (
                                <div className="flex flex-col gap-1">
                                    {data.order_items.map((item, idx) => (
                                        <div key={idx} className="text-sm">
                                            <span className="font-medium">{item.quantity}x</span>{' '}
                                            <span>{item.item_name || 'N/A'}</span>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <span className="text-gray-400">No items</span>
                            )}
                        </td>
                        <td className="db-table-body-td">{data.total}</td>
                        <td className="db-table-body-td">{data.discount}</td>
                        <td className="db-table-body-td">{data.delivery_charge}</td>
                        <td className="db-table-body-td">{data.payment_method_id && data.payment_method_id != '1' ? data.payment_method_id : 'Cash'}</td>
                        <td className="db-table-body-td"> {data?.payment_status && paymentStatusOptionList.find((da) => da.value === data?.payment_status).label}</td>
                    </tr>
                ))
            ) : (
                <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
            )}
        </TableWrapServerSide>
    );
};

export default DataTable;
